import { render, staticRenderFns } from "./CortesView.vue?vue&type=template&id=df882bde"
import script from "./CortesView.vue?vue&type=script&lang=js"
export * from "./CortesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports